/**
 * leaflet 的扩展。
 * 1. 增加适用于天地图的CRS（EPSG4490）
 * 2. 增加自定义加载边界的TileLayer(CustomArcGISServerLayer)
 * 3. 增加可定义多个地图接口地址和绽放级别的TileLayer（SplitZoomLevelLayer),用于支持不同绽放级别下从不同地图服务接口加载。
 * (c) 2019 crj
 */
import L from 'leaflet'

/**
 * 适用于天地图的CRS
 */
L.CRS.EPSG4490 = L.extend({}, L.CRS, {
  code: 'EPSG:4490',
  projection: L.Projection.LonLat,
  transformation: new L.Transformation(1 / 360, 0.5, -1 / 360, 0.25),
  distance: function (latlng1, latlng2) {
    // eslint-disable-next-line
    var rad = Math.PI / 180,
      lat1 = latlng1.lat * rad,
      lat2 = latlng2.lat * rad,
      sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2),
      sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2),
      a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon,
      c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    return this.R * c
  }
})

/**
 * 用于加载自定义图层（目前仅限于山洪项目的地理边界）
 */
L.TileLayer.CustomArcGISServerLayer = L.TileLayer.extend({
  initialize: function (url, options) { // (String, Object)
    this._url = url
    L.setOptions(this, options)
  },

  getTileUrl: function (tilePoint, zoom) { // (Point, Number) -> String
    if (this._adjustTilePoint) {
      this._adjustTilePoint(tilePoint)
    }

    var x = tilePoint.x
    var y = tilePoint.y
    var rowID = '00000000' + y.toString(16)
    var colID = '00000000' + x.toString(16)
    rowID = rowID.substr(rowID.length - 8)
    colID = colID.substr(colID.length - 8)
    return this._url + (this._getZoomForUrl() - 1) + '/R' + rowID + '/C' + colID + '.png'
  }
})

L.tileLayer.CustomArcGISServerLayer = function (url, options) {
  return new L.TileLayer.CustomArcGISServerLayer(url, options)
}

/**
 * 创建图层时支持按不同缩放级别加载不同的地址。
 * 参数 {sources} 为一个数组，每项包含：url, minZoom, maxZoom, subdomains.
 */
L.TileLayer.SplitZoomLevelLayer = L.TileLayer.extend({
  initialize: function (sources, options) { // (Array, Object)
    options = L.setOptions(this, options)
    if (options.bounds) {
      options.bounds = L.latLngBounds(options.bounds)
    }
    this._sources = sources || []
    if (this._sources.length === 0) {
      throw new Error('must set least one map sources.')
    }
    for (let i = 0; i < this._sources.length; i++) {
      let source = this._sources[i]
      source.minZoom = source.minZoom || 0
      source.maxZoom = source.maxZoom || 18
      source.subdomains = source.subdomains || []
    }
  },

  getTileUrl: function (tilePoint) { // (Point) -> String
    let zoom = tilePoint.z
    let url
    let subdomains
    for (let i = 0; i < this._sources.length; i++) {
      let source = this._sources[i]
      if (zoom >= source.minZoom && zoom <= source.maxZoom) {
        url = source.url
        subdomains = source.subdomains
        break
      }
    }

    return L.Util.template(url, L.extend({
      s: this._getSubdomain(tilePoint, subdomains),
      z: tilePoint.z,
      x: tilePoint.x,
      y: tilePoint.y,
      tk: 'fec588eeae1c6d54e17607e33e1e0a51'
    }, this.options))
  },

  _getSubdomain: function (tilePoint, subdomains) {
    if (subdomains.length === 0) return ''
    let index = Math.abs(tilePoint.x + tilePoint.y) % subdomains.length
    return subdomains[index]
  }
})

L.tileLayer.SplitZoomLevelLayer = function (sources, options) {
  return new L.TileLayer.SplitZoomLevelLayer(sources, options)
}

/**
 * 创建针对天地图的地图
 */
var map
L.tianDiTuMap = function (mapEl, options = {}) {
  options.crs = options.crs || L.CRS.EPSG4490
  options.zoom = options.zoom || 12
  options.attributionControl = false
  options.mapType = options.mapType || 0

  /* eslint-disable */
  map = new L.map(mapEl, options)
  var MType = options.mapType == 0 ? 'img_c' : 'vec_c'
  var TType = options.mapType == 0 ? 'cia_c' : 'cva_c'
  var minzoom = options.minZoom || 1 
  var maxzoom = options.maxZoom || 18

  var tileLayer = new L.tileLayer.SplitZoomLevelLayer([
    { url: 'http://t{s}.tianditu.gov.cn/DataServer?T=' + MType + '&x={x}&y={y}&l={z}&tk={tk}', minZoom: minzoom, maxZoom: maxzoom, subdomains: [0, 1, 2, 3, 4, 5, 6, 7] }
    // { url: 'http://srv{s}.zjditu.cn/ZJDOM_2D/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=ZJDOM_2D&FORMAT=image/png&TILEMATRIXSET=esritilematirx&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk={tk}', minZoom: 18, maxZoom: 20, subdomains: [0, 1, 2, 3, 4, 5, 6, 7] }
  ],
  { minZoom: minzoom, maxZoom: maxzoom, },
  [1, 2])

  tileLayer.addTo(map)

  var textLayer = new L.tileLayer('http://t{s}.tianditu.gov.cn/DataServer?T=' + TType + '&X={x}&Y={y}&L={z}&tk=fec588eeae1c6d54e17607e33e1e0a51',
    {
      subdomains: [0, 1, 2, 3, 4, 5, 6, 7],
      minZoom: minzoom < 8 ? 8 : minzoom,
      maxZoom: maxzoom + 2,
      maxNativeZoom: maxzoom + 2
    })
  textLayer.layerName = 'textLayer'
  textLayer.addTo(map)

  return map
}

/**
 * 创建针对天地图的地图   【 0 或不传： 天地图影像图，1：天地图交通图，2：天地图地形图，3：水利一张图影像图,4:水利一张图交通图 】
 */
L.CreateTianDiTuMap = function (mapEl,options = {},reload,remap,getLayer) {
  options.crs = options.crs || L.CRS.EPSG4326//EPSG4490
  options.zoom = options.zoom || 12
  options.attributionControl = false
  options.mapType = options.mapType || 0
  if (!reload) {
    map = new L.map(mapEl, options)
  } else {
    map = remap
  }
  /* eslint-disable */
  var MType = options.mapType == 0 ? 'img_c' : (options.mapType == 2 ? 'ter_c' : 'vec_c')
  var TType = options.mapType == 0 ? 'cia_c' : (options.mapType == 2 ? 'cta_c' : 'cva_c')
  var minzoom = options.minZoom || 1 
  var maxzoom = options.maxZoom || 18
  if (options.mapType == 3) {
    ///水利一张图影像图
    
    tileLayer = new L.tileLayer(
      "https://lspt.slt.zj.gov.cn:18003/yjsh/arcgis/rest/services/basemap/ZJRasterMap/MapServer/tile/{z}/{y}/{x}",
      {
        minZoom: 0,
        maxZoom: 18
      }
    );

    textLayer = new L.tileLayer("https://lspt.slt.zj.gov.cn:18003/yjsh/arcgis/rest/services/basemap/YingXiangZhuJi/MapServer/tile/{z}/{y}/{x}",
    {
      minZoom: 0,
      maxZoom: 18
    });
    textLayer.layerName = 'textLayer'
  } else if (options.mapType == 4) {
    ///水利一张图交通图

    tileLayer = new L.tileLayer(
      "https://lspt.slt.zj.gov.cn:18003/yjsh/arcgis/rest/services/basemap/WYX1029/MapServer/tile/{z}/{y}/{x}",
      {
        minZoom: 0,
        maxZoom: 18
      }
    );

    
    textLayer = new L.tileLayer("https://lspt.slt.zj.gov.cn:18003/yjsh/arcgis/rest/services/basemap/YingXiangZhuJi/MapServer/tile/{z}/{y}/{x}",
    {
      minZoom: 0,
      maxZoom: 18
    });
    textLayer.layerName = 'textLayer'
  } else if (options.mapType == 5) { 
    ///水利一张图地形图
    tileLayer = new L.tileLayer(
      "https://lspt.slt.zj.gov.cn:18003/yjsh/PBS/rest/services/waterMap/MapServer/tile/{z}/{y}/{x}",
      {
        minZoom: 0,
        maxZoom: 18
      }
    );
    
    textLayer = new L.tileLayer("https://lspt.slt.zj.gov.cn:18003/yjsh/arcgis/rest/services/basemap/YingXiangZhuJi/MapServer/tile/{z}/{y}/{x}",
    {
      minZoom: 0,
      maxZoom: 18
    });
    textLayer.layerName = 'textLayer'
  } else {
    //// 0天地图影像图    1天地图地形图  2天地图交通图
    var tileLayer = new L.tileLayer.SplitZoomLevelLayer(
      [
        {
          url:
            "http://t{s}.tianditu.gov.cn/DataServer?T=" +
            MType +
            "&x={x}&y={y}&l={z}&tk={tk}",
          minZoom: minzoom,
          maxZoom: maxzoom,
          subdomains: [0, 1, 2, 3, 4, 5, 6, 7]
        },
        {
          url:
            "http://srv{s}.zjditu.cn/ZJDOM_2D/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=ZJDOM_2D&FORMAT=image/png&TILEMATRIXSET=esritilematirx&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk={tk}",
          minZoom: 18,
          maxZoom: 20,
          subdomains: [0, 1, 2, 3, 4, 5, 6, 7]
        }
      ],
      { minZoom: minzoom, maxZoom: maxzoom },
      [1, 2]
    );
    var textLayer = new L.tileLayer(
      "http://t{s}.tianditu.gov.cn/DataServer?T=" +
      TType +
      "&X={x}&Y={y}&L={z}&tk=f6681d2cb1bca45de4c7b2fef226fdfe",
      {
        subdomains: [0, 1, 2, 3, 4, 5, 6, 7],
        minZoom: minzoom < 8 ? 8 : minzoom,
        maxZoom: maxzoom + 2,
        maxNativeZoom: maxzoom + 2
      }
    );
    textLayer.layerName = "textLayer";
  }

  tileLayer.addTo(map)

  if(textLayer)
    textLayer.addTo(map)
  if (getLayer) {
    return { map: map, tileLayer: tileLayer, textLayer: textLayer }
  }
  return map
}

export default L

